
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.59 17.58"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 1"}},[_c('path',{attrs:{"d":"M14.55 17.58H3.04C1.36 17.58 0 16.21 0 14.54V3.04C0 1.37 1.37 0 3.04 0h11.5c1.68 0 3.04 1.37 3.04 3.04v11.49c0 1.68-1.37 3.04-3.04 3.04zM3.04 1.2c-1.02 0-1.84.83-1.84 1.84v11.49c0 1.02.83 1.84 1.84 1.84h11.5c1.02 0 1.84-.83 1.84-1.84V3.04c0-1.02-.83-1.84-1.84-1.84H3.04z"}}),_c('path',{attrs:{"d":"M8.09 13.01a.57.57 0 01-.39-.16L3.85 9.19a.559.559 0 01-.02-.8c.22-.23.58-.24.8-.02L8 11.57l4.73-6.79c.18-.26.53-.32.79-.14s.32.53.14.79l-5.11 7.33a.55.55 0 01-.41.24h-.06z"}})])])
          )
        }
      }
    